import React from 'react';

const CoverLetterForm = ({ coverData, handlers }) => {
    const {
        updatePersonal,
        updateRecipient,
        updateJobDetails,
        updateOpening,
        updateBody,
        updateClosing,
        updateAdditional
    } = handlers;

    const { personal, recipient, jobDetails, content, additional } = coverData;

    return (
        <div className="space-y-6">
            {/* Your Information */}
            <div className="bg-white rounded-xl p-5 shadow-md">
                <h3 className="font-bold text-gradpath-dark text-lg mb-4 flex items-center gap-2">
                    <i className="fas fa-user text-gradpath-green"></i> Your Information
                </h3>
                <div className="space-y-3">
                    <input
                        type="text"
                        placeholder="Your Full Name"
                        value={personal.fullName}
                        onChange={(e) => updatePersonal('fullName', e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    />
                    <input
                        type="email"
                        placeholder="Your Email"
                        value={personal.email}
                        onChange={(e) => updatePersonal('email', e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    />
                    <input
                        type="tel"
                        placeholder="Your Phone"
                        value={personal.phone}
                        onChange={(e) => updatePersonal('phone', e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    />
                    <input
                        type="text"
                        placeholder="Your Address (Optional)"
                        value={personal.address}
                        onChange={(e) => updatePersonal('address', e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    />
                </div>
            </div>

            {/* Employer Information */}
            <div className="bg-white rounded-xl p-5 shadow-md">
                <h3 className="font-bold text-gradpath-dark text-lg mb-4 flex items-center gap-2">
                    <i className="fas fa-building text-gradpath-green"></i> Employer Information
                </h3>
                <div className="space-y-3">
                    <input
                        type="text"
                        placeholder="Hiring Manager Name (Optional)"
                        value={recipient.hiringManagerName}
                        onChange={(e) => updateRecipient('hiringManagerName', e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    />
                    <input
                        type="text"
                        placeholder="Company Name"
                        value={recipient.companyName}
                        onChange={(e) => updateRecipient('companyName', e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    />
                    <input
                        type="text"
                        placeholder="Company Address (Optional)"
                        value={recipient.companyAddress}
                        onChange={(e) => updateRecipient('companyAddress', e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    />
                </div>
            </div>

            {/* Job Details */}
            <div className="bg-white rounded-xl p-5 shadow-md">
                <h3 className="font-bold text-gradpath-dark text-lg mb-4 flex items-center gap-2">
                    <i className="fas fa-briefcase text-gradpath-green"></i> Job Details
                </h3>
                <div className="space-y-3">
                    <input
                        type="text"
                        placeholder="Job Title"
                        value={jobDetails.jobTitle}
                        onChange={(e) => updateJobDetails('jobTitle', e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    />
                    <input
                        type="text"
                        placeholder="Job Reference Number (Optional)"
                        value={jobDetails.jobReference}
                        onChange={(e) => updateJobDetails('jobReference', e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    />
                </div>
            </div>

            {/* Letter Content */}
            <div className="bg-white rounded-xl p-5 shadow-md">
                <h3 className="font-bold text-gradpath-dark text-lg mb-4 flex items-center gap-2">
                    <i className="fas fa-pen-fancy text-gradpath-green"></i> Letter Content
                </h3>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Opening Paragraph</label>
                        <textarea
                            placeholder="Introduce yourself and express interest in the position..."
                            value={content.opening}
                            onChange={(e) => updateOpening(e.target.value)}
                            rows="4"
                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                        />
                        <p className="text-xs text-gray-500 mt-1">Explain why you're interested in this position and company</p>
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Body Paragraphs</label>
                        <textarea
                            placeholder="Highlight your skills, experience, and achievements..."
                            value={content.body}
                            onChange={(e) => updateBody(e.target.value)}
                            rows="8"
                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                        />
                        <p className="text-xs text-gray-500 mt-1">Showcase your qualifications and how you can add value to the company</p>
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Closing Paragraph</label>
                        <textarea
                            placeholder="Summarize and express enthusiasm for an interview..."
                            value={content.closing}
                            onChange={(e) => updateClosing(e.target.value)}
                            rows="3"
                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                        />
                        <p className="text-xs text-gray-500 mt-1">Thank the employer and express interest in an interview</p>
                    </div>
                </div>
            </div>

            {/* Additional Links */}
            <div className="bg-white rounded-xl p-5 shadow-md">
                <h3 className="font-bold text-gradpath-dark text-lg mb-4 flex items-center gap-2">
                    <i className="fas fa-link text-gradpath-green"></i> Additional Links (Optional)
                </h3>
                <div className="space-y-3">
                    <input
                        type="url"
                        placeholder="Portfolio/GitHub URL"
                        value={additional.portfolio}
                        onChange={(e) => updateAdditional('portfolio', e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    />
                    <input
                        type="url"
                        placeholder="LinkedIn Profile URL"
                        value={additional.linkedin}
                        onChange={(e) => updateAdditional('linkedin', e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    />
                </div>
            </div>
        </div>
    );
};

export default CoverLetterForm;